var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58347 2.94971L12.3358 9.7008L14.0783 7.95837C11.6973 6.5138 8.50841 4.57593 7.07425 3.70463L6.11344 3.12255C5.94361 3.01909 5.76177 2.96337 5.58347 2.94971ZM4.55276 3.75801C4.5391 3.83219 4.52734 3.90673 4.52734 3.98677V17.3288C4.52734 17.3848 4.5386 17.4369 4.54641 17.4902L11.4157 10.6209L4.55276 3.75801ZM15.2233 8.65356L13.256 10.6209L15.189 12.554C16.2132 11.9332 16.9226 11.5022 17.0014 11.4547C17.3495 11.2419 17.5461 10.9208 17.5402 10.5701C17.535 10.2259 17.3384 9.91811 17.0039 9.72875C16.9291 9.68581 16.2293 9.26328 15.2233 8.65356ZM12.3358 11.5411L5.60381 18.2731C5.7346 18.2503 5.86523 18.2113 5.99016 18.1358C6.16325 18.0304 10.8392 15.1935 14.0439 13.2492L12.3358 11.5411Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google_play.7bff0d74863aeaf5bbf4e92b11ce0225.svg";
export { ForwardRef as ReactComponent };